import { useForm } from '@mantine/form';
import { useState } from 'react';
import { validateNumber } from '../../../util/validation/commonValidation';
import type { NewWeeklyTargetDto } from '../types/WeeklyTargetDto';

const defaultWeeklyTarget: NewWeeklyTargetDto = {
	startDate: undefined,
	target: '',
	branchId: '',
};

export function useNewWeeklyTargetForm() {
	const [inputs, setInputs] = useState<NewWeeklyTargetDto>(defaultWeeklyTarget);

	const form = useForm<NewWeeklyTargetDto>({
		mode: 'uncontrolled',
		initialValues: inputs,
		validate: {
			startDate: (value) => {
				if (!value) {
					return 'Please choose a week start date';
				}
			},
			target: (value) => validateNumber(value, false, 0, 10000000, 'Target'),
			branchId: (value) =>
				validateNumber(value, false, 0, 10000000, 'Branch', false),
		},
		onValuesChange: (v) => setInputs(v),
	});

	return { form, inputs };
}
